// extracted by mini-css-extract-plugin
export default {"statsContainer":"StatsCards_statsContainer__ODN1C"};